// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__cdieE","icon":"search_icon__TOKGp","input":"search_input__2sltG","search--light":"search_search--light__J1jZY"};